import { createContext } from 'react';

const scoreboxContext = createContext();

export default scoreboxContext;